import { rtlLanguageList } from '../../constants/language';
import { mapGetters, mapState } from 'vuex';

const setAppElementClass = ()=>{
  const appEl = document.querySelector('#app');

  if (appEl && !appEl.classList.contains('mini_game')) {
    appEl.classList.add('mini_game');
  }
}

const resetAppElementClass  =()=>{
  const appEl = document.querySelector('#app');

  if (appEl && appEl.classList.contains('mini_game')) {
    appEl.classList.remove('mini_game');
    if (appEl.classList.length === 0) {
      appEl.removeAttribute('class');
    }
  }
}

export const addOnGameStyleMixin = {
  data () {
    return {
      stylesheetLinkElIds: {
        puzzle: 'game-puzzle-style',
        lantern: 'game-lantern-style',
      },
    };
  },
  computed: {
    ...mapState('common', [
      'fallingItemsGameCss',
      'puzzleGameCss',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
    ]),
  },
  methods: {
    addStylesheet ({ id = 'game-style', href = '' }) {
      return new Promise((resolve) => {
        const linkEl = document.createElement('link');

        linkEl.id = id;
        linkEl.rel = 'stylesheet';
        linkEl.href = href;
        linkEl.onload = resolve;
        linkEl.onerror = resolve;

        document.head.appendChild(linkEl);
      });
    },
    removeStylesheet ({ id }) {
      const linkEl = document.getElementById(id);

      if (!linkEl) { return; }

      document.head.removeChild(linkEl);
    },
    async addLanternStylesheet () {
      const getLanternStyleHref = (fileName) => `/static/mini_games/lantern_game/${ fileName }.css`;

      setAppElementClass();

      await this.addStylesheet({
        id: this.stylesheetLinkElIds.lantern,
        href: rtlLanguageList.includes(this.getLocale)
          ? getLanternStyleHref(`${ this.fallingItemsGameCss }_AR`)
          : getLanternStyleHref(this.fallingItemsGameCss),
      });
    },
    removeLanternStylesheet () {
      resetAppElementClass();

      this.removeStylesheet({ id: this.stylesheetLinkElIds.lantern });
    },
    async addPuzzleStylesheet () {
      const getPuzzleStyleHref = (fileName) => `/static/mini_games/puzzle_game/${ fileName }.css`;

      setAppElementClass();

      await this.addStylesheet({
        id: this.stylesheetLinkElIds.puzzle,
        href: rtlLanguageList.includes(this.getLocale)
          ? getPuzzleStyleHref(`${ this.puzzleGameCss }_AR`)
          : getPuzzleStyleHref(this.puzzleGameCss),
      });
    },
    removePuzzleStylesheet () {
      resetAppElementClass();

      this.removeStylesheet({ id: this.stylesheetLinkElIds.puzzle });
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/mixins/addOnGameStyle.js